"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoSnippetSchema = void 0;
exports.InfoSnippetSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/info-snippet.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "InfoSnippet",
    "description": "Additional pieces of information that enrich a (e.g.) story with catchy facts",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:info-snippet"
            ]
        },
        "author": {
            "oneOf": [
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
                },
                {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
                }
            ]
        },
        "label": {
            "type": "string",
            "maxLength": 70
        },
        "text": {
            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
        }
    },
    "required": [
        "text",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1zbmlwcGV0LnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvaW5mby1zbmlwcGV0LnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGlCQUFpQixHQUFHO0lBQy9CLEtBQUssRUFBRSxxRUFBcUU7SUFDNUUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsYUFBYTtJQUN0QixhQUFhLEVBQUUsK0VBQStFO0lBQzlGLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHlCQUF5QjthQUMxQjtTQUNGO1FBQ0QsUUFBUSxFQUFFO1lBQ1IsT0FBTyxFQUFFO2dCQUNQO29CQUNFLE1BQU0sRUFBRSxRQUFRO29CQUNoQixNQUFNLEVBQUUsNkRBQTZEO2lCQUN0RTtnQkFDRDtvQkFDRSxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsTUFBTSxFQUFFLHNFQUFzRTtpQkFDL0U7Z0JBQ0Q7b0JBQ0UsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRSwrRUFBK0U7aUJBQ3hGO2dCQUNEO29CQUNFLE1BQU0sRUFBRSxRQUFRO29CQUNoQixNQUFNLEVBQUUsNkVBQTZFO2lCQUN0RjtnQkFDRDtvQkFDRSxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsTUFBTSxFQUFFLDZFQUE2RTtpQkFDdEY7YUFDRjtTQUNGO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsTUFBTSxFQUFFLFFBQVE7WUFDaEIsV0FBVyxFQUFFLEVBQUU7U0FDaEI7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsbUZBQW1GO1NBQzVGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9